import { useAppStore } from '@/stores/app'

// isAuthenticated reports whether an admin token is present. The server is the only authority on
// validity; the router uses this purely to gate routes and redirect to login. Admin tokens carry
// no client claim, so there is no client-picker concept here.
export const isAuthenticated = (): boolean => {
    const appStore = useAppStore()

    return appStore.isLoggedIn()
}
